import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { environment } from '../../environments/environment';


@Component({
  selector: 'SolicitarIpComponent',
  templateUrl: './solicitar-ip.component.html',
  styleUrls: ['./solicitar-ip.component.css']
})
export class SolicitarIpComponent implements OnInit {
  modalAgregarFormGoup = this.formBuilder.group({
    urlControl: [''],
    servidorControl: ['', Validators.required],
    servicioControl: ['', Validators.required],
    plataformaControl: ['', Validators.required],
    rolControl: ['', Validators.required],
    controlObeservaciones: new FormControl(),
    controlDns: new FormControl(),
    checkDns: new FormControl()
  });

  private codigoListaAmbientes = environment.listaCodigoAmbientes;
  private codigoListaUrl = environment.listaCodigoUrl;
  private codigoListaServidor = environment.listaCodigoServidor;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;
  private urlSubject = new Subject<string>();
  private servidorSubject = new Subject<string>();

  companias: Compania[];
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  idCompaniaSeleccionada = -1;
  companiaSeleccionada: Compania = new Compania();
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  ambientes: ListaItem[];
  tiposAsignacion: TipoAsignacion[];
  idTipoAsignacionSeleccionado: number;
  tipoasignacionSeleccionado: TipoAsignacion;
  urls: ListaItem[];
  urlsFiltradas: ListaItem[];
  urlSeleccionado: ListaItem;
  servidores: ListaItem[];
  servidoresFiltrados: ListaItem[];
  servidorSeleccionado: ListaItem;
  servicios: ListaItem[];
  serviciosFiltrados: ListaItem[];
  servicioSeleccionado: ListaItem;
  plataformas: ListaItem[];
  plataformaFiltradas: ListaItem[];
  plataformaSeleccionado: ListaItem;
  roles: ListaItem[];
  rolesFiltrados: ListaItem[];
  rolSeleccionado: ListaItem;
  observaciones: string;
  dns = '';
  asignaciones: Asignacion[] = new Array<Asignacion>();
  agregarActivo = false;
  agregarDns = false;
  modalRef: NgbModalRef;
  solicitudSeleccionada: Solicitud;
  solicitudes: Solicitud[] = new Array<Solicitud>();
  indicadorEdicion = false;
  indexEditar: number;
  lblBotonAgregar: string;
  asignacionesGeneradas: Asignacion[] = new Array<Asignacion>();
  rangoVlan = '';
  error;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private tipoAsignacionService: TipoAsignacionService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.listarCompanias();
    this.listarTiposAsignacion();
    this.cargarListasDialogo();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.seleccionarCompania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe(
      resultado => this.ambientes = resultado
    );
  }

  public listarVlanPorSedeAmbienteCompania(): void {
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.vlanService.vlansPorSedeAmbienteCompania(this.idSedeSeleccionada,
      this.idAmbienteSelecccionado, this.idCompaniaSeleccionada, true).subscribe(
        resultado => this.vlans = resultado
      );
  }

  public listarTiposAsignacion(): void {
    this.idTipoAsignacionSeleccionado = -1;
    this.tiposAsignacion = null;
    this.tipoasignacionSeleccionado = null;
    this.tipoAsignacionService.listarTiposAsignacion().subscribe(
      resultado => this.tiposAsignacion = resultado
    );
  }

  public cambioTipoAsignacion(): void {
    this.tipoAsignacionService.tipoAsignacionPorId(this.idTipoAsignacionSeleccionado).subscribe(
      resultado => this.tipoasignacionSeleccionado = resultado
    );
    if (this.idVlanSeleccionado != -1
      && this.idTipoAsignacionSeleccionado != -1) {
        this.agregarActivo = true;
    }
  }

  public limpiarDialogo(): void {
    this.urlSeleccionado = null;
    this.servidorSeleccionado = null;
    this.servicioSeleccionado = null;
    this.plataformaSeleccionado = null;
    this.rolSeleccionado = null;
    this.solicitudSeleccionada = new Solicitud();
    this.solicitudSeleccionada.tipoAsignacion = new TipoAsignacion();
    this.agregarDns = false;
    this.dns = '';
    this.observaciones = '';
  }

  public mostrarModalSolicitud(servidorModal): void {
    this.cargarListasDialogo();
    this.limpiarDialogo();
    this.modalAgregarFormGoup.reset();
    if (!this.indicadorEdicion) {
      if (this.idTipoAsignacionSeleccionado != -1 && this.idTipoAsignacionSeleccionado != null) {
        this.solicitudSeleccionada.tipoAsignacion = this.tipoasignacionSeleccionado;
        this.lblBotonAgregar = 'Agregar';
      } else {
        return;
      }
    } else {
      this.lblBotonAgregar = 'Editar';
    }
    if (this.solicitudSeleccionada.tipoAsignacion.tipoBase == 'U') {
      this.modalAgregarFormGoup.controls['urlControl'].setValidators(Validators.required);
    } else {
      this.modalAgregarFormGoup.controls['urlControl'].clearValidators();
    }
    this.modalRef = this.modalService.open(servidorModal, { size: 'lg' });

  }


  public ocultarModalSolicitud(): void {
    this.indicadorEdicion = false;
    this.modalRef.close();
  }

  public ListarUrl(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaUrl).subscribe(
      resultado => this.urls = resultado
    );
  }

  public ListarServidor(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServidor).subscribe(
      resultado => this.servidores = resultado
    );
  }

  public ListarServicio(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServicio).subscribe(
      resultado => this.servicios = resultado
    );
  }

  public ListarPlataformas(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaPlataforma).subscribe(
      resultado => this.plataformas = resultado
    );
  }

  public ListarRoles(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaRol).subscribe(
      resultado => this.roles = resultado
    );
  }

  filterRol(event) {
    this.rolesFiltrados = [];
    for (let i = 0; i < this.roles.length; i++) {
      const rol = this.roles[i];
      if (rol.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.rolesFiltrados.push(rol);
      }
    }
      if (this.rolesFiltrados.length == 1 &&
      event.query.toUpperCase() == this.rolesFiltrados[0].valorItem) {
        this.rolSeleccionado = this.rolesFiltrados[0];
      } else {
        const rolNuevo: ListaItem = new ListaItem();
        rolNuevo.codigoItem = (this.roles.length + 1).toString();
        rolNuevo.indicadorHabilitado = true;
        rolNuevo.lista = this.roles[0].lista;
        rolNuevo.valorItem = event.query;
        rolNuevo.idListaItem = null;
        this.rolSeleccionado = rolNuevo;
      }
    }

    filterPlataforma(event) {
      this.plataformaFiltradas = [];
      for (let i = 0; i < this.plataformas.length; i++) {
        const plataforma = this.plataformas[i];
        if (plataforma.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.plataformaFiltradas.push(plataforma);
        }
      }
      if (this.plataformaFiltradas.length == 1  &&
      event.query.toUpperCase() == this.plataformaFiltradas[0].valorItem) {
        this.plataformaSeleccionado = this.plataformaFiltradas[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.plataformas.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.plataformas[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.idListaItem = null;
        this.plataformaSeleccionado = itemNuevo;
      }
    }

    filterServicio(event) {
      this.serviciosFiltrados = [];
      for (let i = 0; i < this.servicios.length; i++) {
        const servicio = this.servicios[i];
        if (servicio.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.serviciosFiltrados.push(servicio);
        }
      }
      if (this.serviciosFiltrados.length == 1 &&
      event.query.toUpperCase() == this.serviciosFiltrados[0].valorItem) {
        this.servicioSeleccionado = this.serviciosFiltrados[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.servicios.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.servicios[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.idListaItem = null;
        this.servicioSeleccionado = itemNuevo;
      }
    }

    filterServidor(event) {
      this.servidoresFiltrados = [];
      for (let i = 0; i < this.servidores.length; i++) {
        const servidor = this.servidores[i];
        if (servidor.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.servidoresFiltrados.push(servidor);
        }
      }
      if (this.servidoresFiltrados.length == 1  &&
      event.query.toUpperCase() == this.servidoresFiltrados[0].valorItem) {
        this.servidorSeleccionado = this.servidoresFiltrados[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.servidores.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.servidores[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
        itemNuevo.idListaItem = null;
        this.servidorSeleccionado = itemNuevo;
      }
    }

    filterUrl(event) {
      this.urlsFiltradas = [];
      for (let i = 0; i < this.urls.length; i++) {
        const url = this.urls[i];
        if (url.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.urlsFiltradas.push(url);
        }
      }
      if (this.urlsFiltradas.length == 1 &&
      event.query.toUpperCase() == this.urlsFiltradas[0].valorItem) {
        this.urlSeleccionado = this.urlsFiltradas[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.urls.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.urls[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
        itemNuevo.idListaItem = null;
        this.urlSeleccionado = itemNuevo;
      }

    }

    settearAsignacion(): Asignacion {
      const asignacion: Asignacion = new Asignacion();
      asignacion.observaciones = this.observaciones == null ? this.observaciones : this.observaciones.toUpperCase();
      asignacion.compania = this.companiaSeleccionada;
      asignacion.configuracionDNS = this.dns == null ? this.dns : this.dns.toUpperCase();
      asignacion.funcion = this.rolSeleccionado;
      asignacion.nombreServidor = this.servidorSeleccionado;
      asignacion.indicadorDns = this.agregarDns;
      if (this.solicitudSeleccionada.tipoAsignacion.tipoBase == 'U') {
        asignacion.nombreURL = this.urlSeleccionado;
      } else {
        asignacion.nombreURL = new ListaItem();
      }
      asignacion.plataforma = this.plataformaSeleccionado;
      asignacion.servicioITNegocio = this.servicioSeleccionado;
      asignacion.tipoAsignacion = this.solicitudSeleccionada.tipoAsignacion;

      return asignacion;
    }

    agregarSolicitud(): void {
      const solicitud: Solicitud = new Solicitud();
      solicitud.asignacion = new Asignacion();
      if (this.indicadorEdicion) {
        this.guardarCambiosSolicitud();
      } else {
        solicitud.asignacion = this.settearAsignacion();
        solicitud.idVlanSeleccionada = this.idVlanSeleccionado;
        solicitud.tipoAsignacion = this.tipoasignacionSeleccionado;
        this.solicitudes.push(solicitud);
        this.verificarListaItem(this.solicitudes.length - 1);
      }
      this.ocultarModalSolicitud();
    }

    borrarSolicitud(solicitud: Solicitud): void {
      const index: number = this.solicitudes.indexOf(solicitud);
      if (index != null && index >= 0) {
        this.solicitudes.splice(index, 1);
      }
    }

    editarSolicitud(solicitud: Solicitud, modal) {
        this.indicadorEdicion = true;
        this.mostrarModalSolicitud(modal);
        this.indexEditar = this.solicitudes.indexOf(solicitud);
        this.urlSeleccionado = solicitud.asignacion.nombreURL;
        this.servidorSeleccionado = solicitud.asignacion.nombreServidor;
        this.servicioSeleccionado = solicitud.asignacion.servicioITNegocio;
        this.plataformaSeleccionado = solicitud.asignacion.plataforma;
        this.rolSeleccionado = solicitud.asignacion.funcion;
        this.dns = solicitud.asignacion.configuracionDNS;
        this.observaciones = solicitud.asignacion.observaciones;
        this.solicitudSeleccionada.tipoAsignacion = solicitud.tipoAsignacion;
        this.solicitudSeleccionada.idVlanSeleccionada = solicitud.idVlanSeleccionada;
        this.agregarDns = solicitud.asignacion.indicadorDns;
    }

    guardarCambiosSolicitud(): void {
      this.solicitudes[this.indexEditar].asignacion = this.settearAsignacion();
      this.verificarListaItem(this.indexEditar);
    }

    asignarDirecciones(modalResultado, cargandoModal): void {
      this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
      this.administradorIpService.guardarAsignaciones(this.solicitudes).subscribe(
        resultado => {
          this.asignacionesGeneradas = resultado;
          this.modalRef.close();
          this.modalRef = this.modalService.open(modalResultado, {backdrop: 'static', keyboard: false, size: 'lg' });
        },
        error => {
          this.error = error;
          this.modalRef.close();
        }
      );
    }

    ocultarModalResultado() {
      this.solicitudes = new Array<Solicitud>();
      this.idCompaniaSeleccionada = -1;
      this.companiaSeleccionada = new Compania();
      this.idCiudadSeleccionada = -1;
      this.idSedeSeleccionada = -1;
      this.idAmbienteSelecccionado = -1;
      this.idVlanSeleccionado = -1;
      this.rangoVlan = '';
      this.idTipoAsignacionSeleccionado = -1;
      this.tipoasignacionSeleccionado = null;
      this.modalRef.close();
    }

    verificarListaItem(index: number): void {
      if (this.solicitudes[index].tipoAsignacion.tipoBase == 'U') {
        if (this.solicitudes[index].asignacion.nombreURL.idListaItem == null) {
          this.guardarListas(this.solicitudes[index].asignacion.nombreURL, index);
        }
      }

      if (this.solicitudes[index].asignacion.nombreServidor.idListaItem == null) {
        this.guardarListas(this.solicitudes[index].asignacion.nombreServidor, index);
      }

      if (this.solicitudes[index].asignacion.servicioITNegocio.idListaItem == null) {
        this.guardarListas(this.solicitudes[index].asignacion.servicioITNegocio, index);
      }

      if (this.solicitudes[index].asignacion.plataforma.idListaItem == null) {
        this.guardarListas(this.solicitudes[index].asignacion.plataforma, index);
      }

      if (this.solicitudes[index].asignacion.funcion.idListaItem == null) {
        this.guardarListas(this.solicitudes[index].asignacion.funcion, index);
      }

    }

    public async guardarListas(item: ListaItem, index: number): Promise<void> {
        const listaItem: ListaItem = await this.listaItemService.guardarListaAsync(item);
        if (item.lista.codigoLista == this.codigoListaServidor) {
          this.solicitudes[index].asignacion.nombreServidor = listaItem;
        }
        if (item.lista.codigoLista == this.codigoListaUrl) {
          this.solicitudes[index].asignacion.nombreURL = listaItem;
        }
        if (item.lista.codigoLista == this.codigoListaServicio) {
          this.solicitudes[index].asignacion.servicioITNegocio = listaItem;
        }
        if (item.lista.codigoLista == this.codigoListaPlataforma) {
          this.solicitudes[index].asignacion.plataforma = listaItem;
        }
        if (item.lista.codigoLista == this.codigoListaRol) {
          this.solicitudes[index].asignacion.funcion = listaItem;
        }
    }

    cargarListasDialogo() {
      this.ListarUrl();
      this.ListarServidor();
      this.ListarServicio();
      this.ListarPlataformas();
      this.ListarRoles();
    }

    mostrarRangoVlan() {
      for (const vlan of this.vlans) {
        if (this.idVlanSeleccionado != -1) {
          if (vlan.idVlan == this.idVlanSeleccionado) {
            this.rangoVlan = vlan.ipInicialRango + ' - ' + vlan.ipFinalRango;
            break;
          }
        } else {
          this.rangoVlan = '';
        }
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/solicitar-ip/solicitar-ip.component.ts